import { Tabs } from "flowbite-react"
import { MdPayments } from "react-icons/md";
import { CgNotes } from "react-icons/cg";
import { renterTheme } from "../renter-dashboard/TabsStyle"
import { NotesInfo } from "../renter-dashboard/NotesInfo";
import { PaymentsTableDelinquencies } from "../../../renter-negativation/components/table/TablePaymentsNegativation";
import { FaCircleUser } from "react-icons/fa6";
import { ImageSelfBlock } from "../settings-blocks/ImageSelf.block";


export function RenterDashboardRescission() {
  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">

        <Tabs
          className="tabs-style"
          theme={renterTheme}
          aria-label="Default tabs"
        >

          <Tabs.Item
            icon={FaCircleUser}
            title={
              <div className="tabs-name-style">
                Planos
              </div>
            }
          >
            <ImageSelfBlock />
          </Tabs.Item>

          <Tabs.Item
            icon={MdPayments}
            title={
              <div className="tabs-name-style">
                Pagamentos
              </div>
            }
          >
            <PaymentsTableDelinquencies />
          </Tabs.Item>


          <Tabs.Item
            icon={CgNotes}
            title={
              <div className="tabs-name-style">
                Observações
              </div>
            }
          >
            <NotesInfo />
          </Tabs.Item>
        </Tabs>
      </section>
    </div>
  )
}